import { render, staticRenderFns } from "./ProductDistributor.vue?vue&type=template&id=4f764a89"
import script from "./ProductDistributor.vue?vue&type=script&lang=js"
export * from "./ProductDistributor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports